/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Bulk pause — optional ``auto_resume_at`` mirrors the single endpoint.
 */
export interface BulkPauseRequest {
  /**
     * @minItems 1
     * @maxItems 200
     */
  enrollment_ids: string[];
  auto_resume_at?: unknown;
}
